/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class AlarmCodeViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log,
        alarmCodeService, alarmTypeService, filterService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.alarmCodeService = alarmCodeService;
        this.alarmTypeService = alarmTypeService;
        this.filterService = filterService;
        this.$log.debug('Controller \'AlarmCodeView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.alarmTypes = [];

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.alarmcode.update';
            initPromise = this.alarmCodeService.getEntity(this.$stateParams.id);
        } else {
            this.updateMode = false;
            this.title = 'ui.alarmcode.creation';
            initPromise = this.$q.resolve();
        }

        this.handleRestServiceCall(this.$q.all({
            entity: initPromise,
            alarmTypes: this.alarmTypeService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            })
        }), data => {
            this.pristineEntity = data.entity;
            this.reset();
            this.alarmTypes = data.alarmTypes;
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        })
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.alarmCodeService.updateEntity(this.alarmCode);
        } else {
            serviceActionPromise = this.alarmCodeService.createEntity(this.alarmCode);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.alarmcode.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.alarm.code.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.alarmCode = angular.copy(this.pristineEntity);
    }
}

export const alarmCodeViewComponent = {
    template: require('./alarmcode-view.html'),
    controller: AlarmCodeViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmCodeView.js